import Steps, { StepsProps } from './Steps'
import Step, { StepProps } from './Step'
export { Directions, Direction, LabelPlacements, LabelPlacement, Statuses, Status } from './interface'
export { Step }
export type { StepsProps, StepProps }
export default Steps
